import * as types from 'actions/actionTypes';

/**
 * action for base list items loading
 */
export function loadAppData(){
    return {type: types.LOAD_APPDATA}
}

/**
 *
 * @param {salvo nello state l'applicazione selezionata} data
 */
export const saveApplication = (data) => dispatch => {
    dispatch({type: types.APP_SAVEAPPLICATION_SUCCESS, data});
}


// WEBPACK FOOTER //
// ./src/actions/appDataActions.js